module.exports = __webpack_public_path__ + "533c1d68cb6d7eabded3f14810c8ae01.png";